import { showTabCloseModal } from "../../../state/actions/modal";
import { useDispatch } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";

// import required modules
import { FreeMode, Navigation } from "swiper/modules";
import { setTabState } from "../../../state/actions/tabStack";


const TabStack = ({ tabs = [], activeTabId, onTabChange, handleCloseTab }) => {
  const dispatch = useDispatch();

  const onCloseTab = (tab) => {
    const promptRequired =
      tab?.options?.promptOnClose === true &&
      ["form2", "container"].includes(tab?.messageType?.toLowerCase());

    // If a prompt model should be shown, trigger it here
    if (promptRequired) {
      dispatch(setTabState(false))
      dispatch(showTabCloseModal(tab));
    } else {
      handleCloseTab(tab);
    }
  };

  if (!tabs?.length || activeTabId === null) return null;

  return (
    <div className="w-full mx-1">
      <Swiper
        slidesPerView="auto"
        freeMode={true}
        navigation={true}
        modules={[FreeMode, Navigation]}
        className="custom-tabs  mySwiper border-b border-[#E8E8E8]"
      >
        {tabs
          .filter(tab => !tab.hidden) // Filter out hidden tabs
          .map((tab, index) => {
            const tabId = tab.options?.tabId;

            return (
              <SwiperSlide key={tabId || index} className="!w-auto">
                <button
                  key={tabId || index}
                  value={tabId}
                  onClick={() => onTabChange(tabId)}
                  className={`!px-2 custom-tab${tabId === activeTabId ? " active-tab" : ""
                    }`}
                >
                  <div className="flex items-center gap-2">
                    <span className="text-size-14 whitespace-nowrap">
                      {tab.options?.title}
                    </span>
                    {index > 0 && (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="size-4"
                        onClick={(e) => {
                          e.stopPropagation();
                          onCloseTab(tab);
                        }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18 18 6M6 6l12 12"
                        />
                      </svg>
                    )}
                  </div>
                </button>
              </SwiperSlide>
            );
          })}
      </Swiper>
    </div>
  );
};

export default TabStack;
